import { IconButton, Tooltip } from '@mui/material'
import { metodoPrograma } from '../../../components/api'
import Programa from '../../../components/Programa/Programa'
import Table from '../../../components/Table'
import { isEqual } from 'lodash'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack, MdDelete } from 'react-icons/md'
import { HiOutlineUserGroup } from 'react-icons/hi'
import { FaUsersCog, FaUserShield } from 'react-icons/fa'
import Edicao from './Edicao'
import TipoDeUsuario from './tipoDeUsuario'
import UsuariosDoContratante from './usuariosDoContratante'
import PerfilDePermissao from './perfilDePermissao'

const Contratante = () => {
  const [listaContratante, setListaContratante] = useState([])

  const buscaLista = useCallback(async () => {
    const res = await metodoPrograma('listaContratante')
    setListaContratante(res.lista || [])
  }, [])

  useEffect(() => {
    buscaLista()
  }, [buscaLista])

  const exclui = (l) => async (e) => {
    e.stopPropagation()
    if (
      !window.confirm(
        'Mas você tem CERTEZA que deseja excluir o contratante ' + l[2] + '?',
      )
    )
      return
    await metodoPrograma('inativaContratante', { idContratante: l[0] })
    await buscaLista()
  }

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [linhaSelecionada, setLinhaSelecionada] = useState([])

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar Contratante">
            <IconButton onClick={() => setTela('adicionarContratante')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <>
            <Tooltip title="Voltar">
              <IconButton onClick={voltar}>
                <MdArrowBack />
              </IconButton>
            </Tooltip>
            <Tooltip title="Tipos de Usuário">
              <IconButton onClick={() => setTela('listaTipoDeUsuario')}>
                <FaUsersCog />
              </IconButton>
            </Tooltip>
            <Tooltip title="Usuários do Contratante">
              <IconButton onClick={() => setTela('listaUsuariosDoContratante')}>
                <HiOutlineUserGroup />
              </IconButton>
            </Tooltip>
            <Tooltip title="Perfil de Permissão">
              <IconButton onClick={() => setTela('listaPerfilDePermissao')}>
                <FaUserShield />
              </IconButton>
            </Tooltip>
          </>,
        )
        break
      case 'tiposUsuarioOpcoes':
        setFerramentas(
          <>
            <Tooltip title="Voltar">
              <IconButton onClick={voltar}>
                <MdArrowBack />
              </IconButton>
            </Tooltip>
            <Tooltip title="Adicionar Tipo Usuário">
              <IconButton
                onClick={() => setTela('adicionarTiposUsuarioOpcoes')}
              >
                <MdAdd />
              </IconButton>
            </Tooltip>
          </>,
        )
        break
      case 'tiposUsuario':
        setFerramentas(
          <>
            <Tooltip title="Voltar">
              <IconButton onClick={voltar}>
                <MdArrowBack />
              </IconButton>
            </Tooltip>
          </>,
        )
        break
      case 'adicionarContratante':
        setFerramentas(
          <>
            <Tooltip title="Voltar">
              <IconButton onClick={voltar}>
                <MdArrowBack />
              </IconButton>
            </Tooltip>
          </>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  const voltar = () => {
    buscaLista()
    setTela('lista')
    setLinhaSelecionada(undefined)
  }

  const handleClick = async (_, linha) => {
    setLinhaSelecionada(linha)
    setTela('opcoes')
  }
  return (
    <Programa codigo="Contratante" ferramentas={ferramentas}>
      {tela === 'lista' && (
        <>
          <h4>Listagem de Contratantes</h4>
          <Table
            dados={listaContratante}
            head={[
              'ID',
              'Descrição',
              'Responsável',
              'Inclusão',
              'Exclusão',
              '',
            ]}
            line={(l) => [l[0], l[1], l[2], l[9], l[10], '']}
            columnOptions={[
              {
                alias: 5,
                customJsx: ({ linhaOriginal }) =>
                  linhaOriginal[10] ? (
                    ''
                  ) : (
                    <IconButton size="small" onClick={exclui(linhaOriginal)}>
                      <MdDelete />
                    </IconButton>
                  ),
              },
            ]}
            onClick={handleClick}
          />
        </>
      )}
      {tela === 'opcoes' && (
        <Edicao
          {...{
            linhaSelecionada,
            voltar,
            tela,
            setTela,
            ferramentas,
            setFerramentas,
          }}
        />
      )}
      {tela === 'adicionarContratante' && (
        <Edicao
          {...{
            linhaSelecionada,
            voltar,
            tela,
            setTela,
            ferramentas,
            setFerramentas,
          }}
        />
      )}
      {tela === 'listaTipoDeUsuario' && (
        <TipoDeUsuario
          {...{
            linhaSelecionada,
            voltar,
            tela,
            setTela,
            ferramentas,
            setFerramentas,
          }}
        />
      )}
      {tela === 'listaUsuariosDoContratante' && (
        <UsuariosDoContratante
          {...{
            linhaSelecionada,
            voltar,
            tela,
            setTela,
            ferramentas,
            setFerramentas,
          }}
        />
      )}
      {tela === 'listaPerfilDePermissao' && (
        <PerfilDePermissao
          {...{
            linhaSelecionada,
            voltar,
            tela,
            setTela,
            ferramentas,
            setFerramentas,
          }}
        />
      )}
    </Programa>
  )
}

export default memo(Contratante, isEqual)
